export default class CDSConfig {

    constructor() {
        this.code = '';
        this.message = '';
        this.publications = {};
    }

}
